import { Tooltip } from "@mui/material";
import { format, formatDistanceToNow, isAfter, subHours } from "date-fns";

type Props = {
  value: Date | number | string;
  showTime?: boolean;
  relative?: boolean;
  utcTooltip?: boolean;
};

export const DateTimeValue = ({
  value,
  showTime = false,
  relative = true,
  utcTooltip = false,
}: Props) => {
  const date = new Date(value);
  const tooltip = utcTooltip
    ? date.toISOString()
    : format(date, "MMM d, yyyy HH:mm");

  if (showTime) {
    const twentyFourHoursAgo = subHours(new Date(), 24);
    const isWithin24Hours = isAfter(date, twentyFourHoursAgo);
    if (relative && isWithin24Hours) {
      const relativeTime = formatDistanceToNow(date, { addSuffix: true });
      return (
        <Tooltip title={tooltip} arrow placement="top">
          <span>{relativeTime}</span>
        </Tooltip>
      );
    }
    return utcTooltip ? (
      <Tooltip title={tooltip} arrow placement="top">
        <span>{format(date, "MMM d, yyyy HH:mm")}</span>
      </Tooltip>
    ) : (
      <span>{format(date, "MMM d, yyyy HH:mm")}</span>
    );
  }

  return (
    <Tooltip title={tooltip} arrow placement="top">
      <span>{format(date, "MMM d, yyyy")}</span>
    </Tooltip>
  );
};
